export const colors = {
  red: 'red',
  blue: 'blue',
  green: 'green',
  brand: 'brand',
  yellow: 'yellow',
  indigo: 'indigo',
  purple: 'purple',
  pink: 'pink',
  gray: 'gray',
  orange: 'orange'
};
